export default "__VITE_ASSET__BCtGY4gH__"